import React from 'react'

type UseScrollToBottomParams<T extends (...args: never[]) => unknown> = {
  getElement: (...args: Parameters<T>) => HTMLElement
  threshold?: number
  onScrollToBottom: () => void
}

/**
 * 要素が一番下までスクロールされたことを検出するカスタムフックです。
 *
 * @param params - パラメーター。
 * @returns 要素のスクロールイベントのハンドラー関数。
 */
export const useScrollToBottom = <T extends (...args: never[]) => unknown>(
  params: UseScrollToBottomParams<T>,
) =>
  React.useCallback(
    (...args: Parameters<T>) => {
      const element = params.getElement(...args)
      const { clientHeight, scrollHeight, scrollTop } = element
      const scrollBottom = scrollHeight - clientHeight - scrollTop
      const threshold = params.threshold ?? clientHeight / 5

      if (scrollBottom < threshold) {
        params.onScrollToBottom()
      }
    },
    [params],
  )
